import { useSelector } from 'react-redux';

// @ts-expect-error untyped dependency
import { selectUserId } from 'dashboard-lib/public/userInfo';
// @ts-expect-error untyped dependency
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
import { useDataSourceProperties } from 'platform-dashboard-ui/hooks/use-data-source-properties';
import { useCurrencyCode } from '../../../../lib/dashboardFilters/useCurrencyCode';
import { getFilterQueryFormatOperator } from '../../../../lib/dashboardFilters/filterConversionHelpers';
import FilterListItem from './FilterListItem';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { getDataSourceKeysForFilters } from '../../../../ducks/applied-dashboard-filters/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardFiltersList = ConnectReferenceResolvers(resolvers => ({
  resolvers
}))(props => {
  const {
    filters,
    resolvers
  } = props;
  const userId = useSelector(selectUserId);
  const currencyCode = useCurrencyCode();
  const {
    isLoading,
    propertiesByDataSource: dataSourcesProperties
  } = useDataSourceProperties(getDataSourceKeysForFilters(filters));
  if (!currencyCode || !filters.length) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIList, {
    className: "m-y-2 p-left-4",
    styled: true,
    children: [isLoading && /*#__PURE__*/_jsx(UILoadingSpinner, {}), !isLoading && filters.map((filter, idx) => {
      const {
        dataSource
      } = filter;
      const operator = getFilterQueryFormatOperator(filter, dataSourcesProperties[dataSource]);
      if (!operator) {
        return null;
      }
      return /*#__PURE__*/_jsx(FilterListItem, {
        dataSource: dataSource,
        operator: operator,
        resolvers: resolvers,
        userId: userId,
        currencyCode: currencyCode
      }, `dashboard-filter-list-item-${idx}`);
    })]
  });
});